import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

class QuantitySelectorComponent extends Component {

  get step() {
    return parseFloat(this.dataset.step || 0.5);
  }

  increaseQuantity(event) {
    event.preventDefault();

    const current = parseFloat(this.refs.quantityInput.value || 0);
    const newValue = current + this.step;

    this.#updateQuantity(newValue);
  }

  decreaseQuantity(event) {
    event.preventDefault();

    const current = parseFloat(this.refs.quantityInput.value || 0);

    if (current <= this.step) return;

    const newValue = current - this.step;

    this.#updateQuantity(newValue);
  }

  selectInputValue(event) {
    const { quantityInput } = this.refs;

    if (
      event.target instanceof HTMLInputElement &&
      document.activeElement === quantityInput
    ) {
      quantityInput.select();
    }
  }

  setQuantity(event) {
    if (!(event.target instanceof HTMLInputElement)) return;

    const value = parseFloat(event.target.value);

    if (Number.isNaN(value)) return;

    this.#updateQuantity(value);
  }

  #updateQuantity(uiValue) {
  const { quantityInput, quantityReal } = this.refs;

  const step = this.step;

  // GET MAX FROM INPUT
  const max = parseFloat(quantityInput.max);

  // MINIMUM
  if (uiValue < step) {
    uiValue = step;
  }

  // MAXIMUM
  if (!Number.isNaN(max) && uiValue > max) {
    uiValue = max;
  }

  // ROUND TO STEP
  uiValue = Math.round(uiValue / step) * step;

  // UPDATE UI
  quantityInput.value = Number.isInteger(uiValue)
    ? uiValue
    : uiValue.toFixed(1);

  // CONVERT TO SHOPIFY REAL QUANTITY
  const realQuantity = Math.round(uiValue / step);

  // UPDATE REAL INPUT
  quantityReal.value = realQuantity;

  // DISPATCH EVENT
  quantityInput.dispatchEvent(
    new QuantitySelectorUpdateEvent(
      realQuantity,
      Number(quantityInput.dataset.cartLine)
    )
  );
}

  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing quantityInput');
    }

    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define(
    'quantity-selector-component',
    QuantitySelectorComponent
  );
}